import { Fragment } from "react";
import { Outlet } from "react-location";
import SSL from "../../assets/ssl-big.png";
import visalLogo from "../../assets/visal-logo.webp";

function Auth() {
  return (
    <Fragment>
      <div className="min-h-screen bg-white flex">
        <div className="hidden lg:block bg-white relative w-0 flex-1">
          <div className="h-full w-full flex flex-col items-center">
            <img
              src={require("../../assets/logo.png")}
              className="w-1/2 h-1/2 rounded-b-full"
              alt=""
            />
            <div className="space-y-5 w-full flex flex-col items-center h-full">
              <h4 className="text-xl font-mono w-1/2 mt-3 text-center">
                Kava is a reinsurance ecosystem that provides our reinsurance
                network with business information from our network of brokers.
              </h4>
              <ul className="bg-red-200 w-[50%] list-disc list-inside p-3 my-4 rounded-lg">
                <li className={"text-red-800 font-poppins"}>
                  Enter your corporate email address in the field provided.
                </li>
                <li className={"text-red-800 font-poppins"}>
                  ⁠⁠Check your email for your OTP (One Time Password) and
                  password to login on to the platform.
                </li>
              </ul>
              <h4 className="text-sm w-1/2 font-light mt-3 text-center">
                Login and enjoy access to data on reinsurance offers including
                viewing credit notes and tracking payments. Don't have access?
                Send an email to info@comfytechnology.tech
              </h4>
              <div>
                <h2 className="text-xl font-medium">Our Clients</h2>
              </div>
              <div className="flex flex-row justify-center items-center space-x-5">
                <div>
                  <img
                    className="h-20 w-32 object-contain rounded-full"
                    src={visalLogo}
                    alt=""
                  />
                </div>
                <div>
                  <img
                    className="h-32 w-32 object-contain rounded-full"
                    src="https://kekrebrokerapp.com/static/media/logo-kek-1.921b9b2502d3129fadaa.png"
                    alt=""
                  />
                </div>
                <div>
                  <img
                    className="h-20 w-32 object-contain rounded-non"
                    src="https://iriskre.com/static/media/irisk-logo-big.c27e3721.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 bg-gray-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96 relative pb-16">
            {/* Routes go here */}
            <Outlet />
            <div className="absolute bottom-0 right-0">
              <img src={SSL} alt="SSL Certificate" className="w-auto h-12" />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Auth;
